import React from 'react';
import { TrainingContentProps } from './Types';
import {
  getHeaderLevel,
  getTextAlignmentClass,
  getTextColorClass,
} from '../../../services/generalUtils';
import CustomHeader from '../CustomHeader';
import CustomMaskIcon from '../../common/CustomMaskIcon';
import CommonButton from '../../common/CommonButton';
import { toAgilityButtonStyle } from '../../../services/agilityDataUtils';
import { themeColor } from '../../../services/styleUtils/colorUtils';
import { useTheme } from '@mui/material/styles';
import DisplayLink from '../../common/subcomponents/DisplayLink';

const TrainingContent = ({
  contentTitle,
  contentTitleStyle,
  options,
  iconColor,
  shortTextColor,
  desktopAlignment,
  mobileAlignment,
  contactUsButton,
  contactUsButtonStyle,
  contentBackgroundColor,
}: TrainingContentProps) => {
  const theme = useTheme();
  return (
    <div
      className={
        'bg-[#F4F4F4] p-10 max-w-full h-auto shadow-[0_4px_4px_0_#00000040]'
      }
      style={
        contentBackgroundColor
          ? { backgroundColor: contentBackgroundColor }
          : {}
      }
    >
      <CustomHeader
        text={contentTitle}
        headerStyle={{
          color: getTextColorClass(themeColor(theme, contentTitleStyle?.color)),
          level: getHeaderLevel(contentTitleStyle?.level),
          alignment: getTextAlignmentClass(contentTitleStyle?.alignment),
          className:
            "mb-8 font-['Roboto_Slab'] font-semibold text-[24px] leading-[18px] md:font-['Roboto_Slab'] md:font-semibold md:text-[24px] md:leading-[18px]",
        }}
      />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {options.map((item, index) => (
          <div key={index} className="text-center">
            <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center">
              <CustomMaskIcon
                url={item.iconImage.url}
                alt={item.iconImage.label}
                color={iconColor}
                width={56}
                height={56}
                className="w-full h-full object-contain"
              />
            </div>
            {item.optionLink && item.optionLink.href ? (
              <DisplayLink
                link={item.optionLink}
                fallbackText={item.text}
                containerClassName={`font-['Source_Sans_3'] text-base font-medium leading-6 ${desktopAlignment ? `lg:text-${desktopAlignment}` : ''} ${mobileAlignment ? `text-${mobileAlignment}` : ''}`}
                containerStyle={{ color: shortTextColor || undefined }}
              />
            ) : (
              <p
                className={`font-['Source_Sans_3'] text-base font-medium leading-6 text-center ${desktopAlignment ? `lg:text-${desktopAlignment}` : ''} ${mobileAlignment ? `text-${mobileAlignment}` : ''}`}
                style={shortTextColor ? { color: shortTextColor } : {}}
              >
                {item.text}
              </p>
            )}
          </div>
        ))}
      </div>
      {contactUsButton && contactUsButton.href && (
        <div className="text-center mt-12">
          <CommonButton
            text={contactUsButton.text}
            link={{
              href: contactUsButton.href,
              target: contactUsButton.target || '_self',
            }}
            buttonStyle={
              contactUsButtonStyle
                ? toAgilityButtonStyle(contactUsButtonStyle)
                : undefined
            }
            size="md"
          />
        </div>
      )}
    </div>
  );
};

export default TrainingContent;
